import React from "react";
import { YhModal } from "../../../ui/YhModal";

interface CustomProps {
  handleDialogClose?: Function | undefined;
  closable?: boolean;
  width?: string;
  isDialogOpen: boolean;
  dialogTitleContent?: React.ReactNode;
  dialogBodyContent?: React.ReactNode;
  dialogFooterContent?: React.ReactNode;
  dialogFooterClass?: any;
  closeButtonVisibility?: boolean;
  fullScreen?: boolean;
  borderRadius?: string;
  dialogBodyStyle?: any;
  dialogHeaderContent?: React.ReactNode;
  type?: string;
}

const CustomDialog = (props: CustomProps) => {
  const width = props.width ? props.width : "60%";
  const title =
    props.dialogTitleContent || props.dialogHeaderContent || undefined;

  return (
    <YhModal
      open={props.isDialogOpen}
      onClose={
        props.closable && props.handleDialogClose
          ? () => props.handleDialogClose!()
          : undefined
      }
      closable={!!props.closable && !!props.closeButtonVisibility}
      title={title}
      width={width}
      fullScreen={props.fullScreen}
      className={props.type === "project" ? "overflow-hidden" : ""}
      footer={props.dialogFooterContent}
    >
      {props.dialogBodyContent}
    </YhModal>
  );
};

export default CustomDialog;
